module.exports = __webpack_public_path__ + "img/car_shina2_13.43e40ac4.jpg";